import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {ActionBox} from 'shells/action-box/action-box';
import {ErrorIcon, SuccessIcon, WarningIcon} from 'shells/action-box/action-icons';
import {Link} from 'shells/link/link';

import type {EditionFragment_from as EditionFrom} from 'nutshell-graphql-types';

import type {EditionSecurityInfo} from './helpers';

type Props = {
    editionFrom: EditionFrom;
    userFacingNoun: string;
    canAccessSetup: boolean;
    editionSecurityInfo: EditionSecurityInfo | null | undefined;
};

export function DKIMWarning(props: Props) {
    const {editionFrom, editionSecurityInfo} = props;

    if (editionSecurityInfo && editionSecurityInfo.nutshellDkimVerified) {
        // Success state - nutshell DKIM records exist
        if (NutClientConfig.hasDmarcSetup && !editionSecurityInfo.dmarcDmarcVerified) {
            return (
                <ActionBox
                    size='large'
                    title='From'
                    subtitle='Set up DMARC records for more reliable email delivery'
                    actionElement={
                        props.canAccessSetup ? (
                            // @ts-expect-error
                            <Link variant='primary' to='/setup/domains' as={RoutedLink}>
                                Configure
                            </Link>
                        ) : undefined
                    }
                    icon={<WarningIcon />}
                />
            );
        } else {
            return (
                <ActionBox
                    size='large'
                    title='From'
                    subtitle={`This ${props.userFacingNoun} has a verified sender`}
                    icon={<SuccessIcon />}
                    actionElement={undefined}
                />
            );
        }
    } else if (
        !editionSecurityInfo ||
        (!editionSecurityInfo.sesDkimVerified && !editionSecurityInfo.nutshellDkimVerified)
    ) {
        // DKIM was never set up
        return (
            <ActionBox
                size='large'
                title='From'
                subtitle='Verify DNS records to help ensure successful deliveries to inboxes'
                actionElement={
                    props.canAccessSetup ? (
                        <Link
                            variant='primary'
                            to='/email-marketing/sender-address'
                            // @ts-expect-error
                            as={RoutedLink}
                        >
                            Configure
                        </Link>
                    ) : undefined
                }
                icon={<WarningIcon />}
            />
        );
    } else {
        // DKIM Migration is necessary
        return (
            <ActionBox
                size='large'
                title='From'
                subtitle={`${editionFrom.emailAddress.address} requires DNS keys to ensure successful deliveries`}
                actionElement={
                    props.canAccessSetup ? (
                        <Link
                            variant='primary'
                            to='/email-marketing/sender-address'
                            // @ts-expect-error
                            as={RoutedLink}
                        >
                            Configure
                        </Link>
                    ) : undefined
                }
                icon={<ErrorIcon />}
            />
        );
    }
}
